<script setup>
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { apiErrorMessage } from '../api.js'
import { useI18n } from '../i18n.js'
import { getControllerSummary } from '../pts2/controllers.js'

const route = useRoute()
const router = useRouter()
const { t } = useI18n()
const error = ref('')

async function redirectToStationAdministration() {
  try {
    const controller = await getControllerSummary(route.params.controllerId)
    await router.replace({
      name: 'platform-station-detail',
      params: { stationId: controller.stationId },
      query: { tab: 'pts2', controllerId: controller.id },
    })
  } catch (cause) {
    error.value = apiErrorMessage(t, cause, 'pts2SettingsUnavailable')
  }
}

onMounted(redirectToStationAdministration)
</script>

<template>
  <section class="platform-page">
    <p v-if="!error" class="platform-loading">{{ t('pts2SettingsRedirecting') }}</p>
    <p v-else class="notice error" role="alert">{{ error }}</p>
  </section>
</template>
